import * as vp from 'vopay';
import { Box, Button, Title, Card } from 'vopay';

import React from 'react';
import { useHistory } from 'react-router-dom';
import { Table } from 'UI';

import { useBillingPackages } from '@/providers/BillingPackages.provider';
import { useNavMenu } from '@/providers/NavMenu.provider';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import { usePartnerData } from '@/providers/PartnerData.provider';
import { useTranslation } from 'react-i18next';

type BillingPackageInfo = {
  packageId: string;
  packageName: string;
  dateAdded: string;
  createdBy: string;
  currency: string;
  country: string;
};

const BillingPackageList = (): React.JSX.Element => {
  const { getModuleTitle } = useNavMenu();
  const { canCreatePackage } = useModuleFeatureFlag('billingPackages');
  const history = useHistory();
  const { billingPackages } = useBillingPackages();
  const { t } = useTranslation('translations', { keyPrefix: 'BillingPackage' });
  const {
    response: { isRoleViewOnly },
  } = usePartnerData();

  const tableProps: vp.TableProps<BillingPackageInfo> = {
    id: 'billing-package-list',
    version: '2',
    zebra: true,
    columns: [
      {
        id: 'packageName',
        header: t('Table.packageName'),
        align: 'left',
        template: ({ data }) => (
          <Table.Link
            to={{
              pathname: `billing-packages/package/${data.packageId}`,
              search: `?packageName=${encodeURIComponent(data.packageName)}`,
            }}
          >
            {data.packageName}
          </Table.Link>
        ),
      },
      {
        id: 'dateAdded',
        header: t('Table.dateAdded'),
        align: 'left',
        field: 'dateAdded',
      },
      {
        id: 'createdBy',
        header: t('Table.createdBy'),
        align: 'left',
        field: 'createdBy',
      },
      {
        id: 'currency',
        header: t('Table.currency'),
        align: 'left',
        field: 'currency',
      },
    ],
    rows: Object.values(billingPackages.mappedValues).map((billingPackage) => ({
      id: billingPackage.packageId,
      data: billingPackage,
    })),
  };

  return (
    <Box flx="col" gapSize="36px">
      <Box mb="md" jc="sb">
        <Title title={getModuleTitle()} />
        {canCreatePackage && (
          <Button
            id="billing-package-addPackage"
            label={t('addPackageButton')}
            isDisabled={isRoleViewOnly}
            onClick={() => history.push('/billing-packages/create')}
          />
        )}
      </Box>
      <Card
        style={{
          padding: '16px',
        }}
      >
        <Table {...tableProps} />
      </Card>
    </Box>
  );
};

export default BillingPackageList;
